<template>
    <!-- Ionic modal provides --max-height -->
    <div
        class="pt-6 h-(--max-height) flex flex-col"
        :data-cy="cypressHandle"
    >
        <div
            class="pt-2 pb-4 px-4 border-b border-transparent transition-colors duration-150"
            :class="{ 'border-gray-300!': scrollY > 0 }"
        >
            <p class="text-lg font-medium mb-1">
                {{ title }}
            </p>
            <div class="flex w-full items-center">
                <DBadge type="base">
                    {{ modelValue?.length ?? 0 }} selected
                </DBadge>
                <DButton
                    v-if="multiple"
                    theme="text-link"
                    class="ml-auto"
                    data-cy="toggle-all"
                    @click="toggleAll"
                >
                    {{ allSelected ? 'Deselect all' : 'Select all' }}
                </DButton>
            </div>
        </div>
        <IonContent
            ref="contentScroll"
            class="flex-1"
            scroll-events
            @ion-scroll="onScroll"
        >
            <div class="pb-(--beyond-safe-area-inset-bottom)">
                <UISimple
                    v-for="option in optionsWithEnabled"
                    :key="option.value"
                    @click="toggle(option.value)"
                >
                    <template #title>
                        {{ option.title }}
                    </template>
                    <template #right-content>
                        <DCheckbox
                            v-if="multiple"
                            :model-value="option.enabled"
                            class="pointer-events-none scale-[1.15] mr-2!"
                        />
                        <DSwitch
                            v-else
                            :model-value="option.enabled"
                            class="pointer-events-none"
                        />
                    </template>
                </UISimple>
            </div>
        </IonContent>
    </div>
</template>
<script setup>
    import {
        DBadge, DButton, DSwitch, DCheckbox,
    } from '@digistorm/spark'
    import { includes } from 'lodash'
    import UISimple from '@/components/ui/ListItemLayouts/UISimple.vue'

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        title: String,
        options: {
            type: Array,
            required: true,
        },
        multiple: Boolean,
        modelValue: {
            type: Array,
            required: true,
            default: () => [],
        },
        onModelValueUpdate: Function,
        cypressHandle: {
            type: String,
            default: 'quick-selection-modal',
        },
    })

    const scrollY = ref(0)

    const allSelected = computed(() => {
        return props.modelValue.length === props.options.length
    })

    const optionsWithEnabled = computed(() => {
        return map(props.options ?? [], (option) => ({
            ...option,
            enabled: allSelected.value || props.modelValue.includes(option.value),
        }))
    })

    const onScroll = (e) => {
        scrollY.value = e.detail.scrollTop
    }

    const update = (value) => {
        emit('update:modelValue', value)
        props.onModelValueUpdate?.(value)
    }

    const toggleAll = () => {
        if (allSelected.value) {
            update([])
        } else {
            update(map(props.options, 'value'))
        }
    }

    const toggle = (value) => {
        if (!props.multiple) {
            if (includes(props.modelValue, value)) {
                update([])
            } else {
                update([value])
            }
            return
        }

        if (includes(props.modelValue, value)) {
            update(props.modelValue.filter((val) => val !== value))
        } else {
            update([...props.modelValue, value])
        }
    }
</script>
